import { IncentivizeRewardsDto, SpoolDto } from '../../../../../../../../types/spool-local';
import { useContext, useEffect, useState } from 'react';
import CollapsibleArea, {
    CollapsibleAreaContext,
} from '../../../../../../../components/CollapsibleArea';
import { TabsContext } from '../../../../../../../components/Tabs';
import useIsMounted from '../../../../../../../hooks/useIsMounted';
import AddIncentive from './AddIncentivize';
import SpoolIncentive from './SpoolIncentive';

type Props = {
    incentivizedRewards: IncentivizeRewardsDto[];
    spoolDetails: SpoolDto;
};

const IncentivizeSpool: React.FC<Props> = ({ incentivizedRewards, spoolDetails }) => {
    const { updateHeight } = useContext(TabsContext);
    const { updateCollapsedHeight } = useContext(CollapsibleAreaContext);
    const isMounted = useIsMounted();

    const [collapsed, setCollapsed] = useState(false);

    const toggle = () => setCollapsed((prev) => !prev);

    useEffect(() => {
        updateHeight();

        const interval = setInterval(() => {
            isMounted() && updateCollapsedHeight();
        }, 100);

        const timeout = setTimeout(() => {
            clearInterval(interval);
        }, 500);

        return () => {
            clearInterval(interval);
            clearTimeout(timeout);
        };

        // eslint-disable-next-line
    }, [collapsed, isMounted]);

    return (
        <div className='incentivize-spool'>
            <div className='current-incentives-container'>
                <span>Your Spool's Current Incentives</span>
                {incentivizedRewards.length ? (
                    incentivizedRewards
                        .filter(({ isRemoved }) => !isRemoved)
                        .map((incentivizedReward, index) => (
                            <SpoolIncentive
                                key={index}
                                incentivizedReward={incentivizedReward}
                                index={index}
                            />
                        ))
                ) : (
                    <p>
                        Your Spool is not currently incentivized. <br />
                        Use the “Add Incentive Token” field below to optionally
                        incentivize your Spool.
                    </p>
                )}
            </div>

            <div className='add-incentive-tokens-container'>
                <div
                    className={`add-incentive-tokens-trigger ${
                        collapsed ? 'collapsed' : ''
                    }`}
                    onClick={toggle}
                >
                    <div className='arrow-container'>
                        <div className='arrow' />
                    </div>
                    <div className='trigger-text'>
                        <span>Add incentive Token</span>
                    </div>
                    <div className='line' />
                </div>
                <CollapsibleArea className='add-incentive-tokens' collapsed={collapsed}>
                    <AddIncentive spoolDetails={spoolDetails} />
                </CollapsibleArea>
            </div>
        </div>
    );
};

export default IncentivizeSpool;
